import Card from 'creditcards/card';
import Type from 'creditcards-types/type';
import visa from 'creditcards-types/types/visa';
import mastercard from 'creditcards-types/types/mastercard';
import amex from 'creditcards-types/types/american-express';
import { isPast, year } from 'creditcards/expiration';
import AmericanExpress from '../assets/icons/svg/AmericanExpress';
import MCard from '../assets/icons/svg/Mastercard';
import Visa from '../assets/icons/svg/Visa';
import Mada from '../assets/icons/svg/Mada';
import CardNumber from '../assets/icons/svg/CardNumber';

const CARD_TYPES = {
  AMEX: 'American Express',
  MASTERCARD: 'Mastercard',
  MADA: 'Mada',
  VISA: 'Visa',
};
const mada = new Type({
  name: CARD_TYPES.MADA,
  digits: 16,
  pattern:
    /^(446404|440795|440647|421141|474491|588845|968208|457997|457865|468540|468541|468542|468543|417633|446393|636120|968201|410621|409201|403024|458456|462220|968205|455708|484783|588848|455036|968203|486094|486095|486096|504300|440533|489318|489319|445564|968211|410685|406996|432328|428671|428672|428673|968206|446672|543357|434107|407197|407395|412565|431361|604906|521076|588850|968202|529415|535825|543085|524130|554180|549760|968209|524514|529741|537767|535989|536023|513213|520058|558563|585265|588983|588982|589005|508160|531095|530906|532013|605141|968204|422817|422818|422819|428331|483010|483011|483012|589206|968207|419593|439954|530060|531196|420132|506968)\d{10}$/,
  eagerPattern:
    /^(446404|440795|440647|421141|474491|588845|968208|457997|457865|468540|468541|468542|468543|417633|446393|636120|968201|410621|409201|403024|458456|462220|968205|455708|484783|588848|455036|968203|486094|486095|486096|504300|440533|489318|489319|445564|968211|410685|406996|432328|428671|428672|428673|968206|446672|543357|434107|407197|407395|412565|431361|604906|521076|588850|968202|529415|535825|543085|524130|554180|549760|968209|524514|529741|537767|535989|536023|513213|520058|558563|585265|588983|588982|589005|508160|531095|530906|532013|605141|968204|422817|422818|422819|428331|483010|483011|483012|589206|968207|419593|439954|530060|531196|420132|506968)/,
});
const card = Card([mada, mastercard, visa, amex]);

const limit = (val, max) => {
  if (val.length === 1 && val[0] > max[0]) {
    val = '0' + val;
  }

  if (val.length === 2) {
    if (Number(val) === 0) {
      val = '01';
    } else if (val > max) {
      val = max;
    }
  }
  return val;
};
const cardExpiryFormat = (date) => {
  let month = limit(date.substring(0, 2), '12');
  let year = date.substring(2, 4);
  return month + (year.length ? '/' + year : '');
};

const validateExpiryDate = (date) => {
  const dateMonth = date.substring(0, 2);
  const dateYear = date.substring(3, 5);

  return !isPast(dateMonth, year.parse(dateYear, true));
};

const ICONS = {
  [CARD_TYPES.AMEX]: AmericanExpress,
  [CARD_TYPES.MASTERCARD]: MCard,
  [CARD_TYPES.VISA]: Visa,
  [CARD_TYPES.MADA]: Mada,
  placeHolder: CardNumber,
};
export const getIcon = (cardNumber) => {
  const type = card.type(cardNumber, true);
  if (!type) return ICONS['placeHolder'];
  else return ICONS[type];
};
export const getMask = (cardNumber) => {
  const type = card.type(cardNumber, true);
  return type === CARD_TYPES.AMEX ? '#### ###### #####' : '#### #### #### ####';
};
export const getCVVLength = (cardNumber) => {
  const type = card.type(cardNumber, true);
  return type === CARD_TYPES.AMEX ? '####' : '###';
};
export const withEventHandel = (fun) => (e) => fun(e.target.value);

const isValidCvv = (cvv, cardNumber) => {
  const cardType = card.type(cardNumber, true);
  if (cardNumber === '' || !cardType) {
    return true;
  }
  const CVV_PATTERNS = {
    [CARD_TYPES.AMEX]: /^\d{4}$/,
    [CARD_TYPES.MADA]: /^\d{3}$/,
    [CARD_TYPES.MASTERCARD]: /^\d{3}$/,
    [CARD_TYPES.VISA]: /^\d{3}$/,
  };
  return CVV_PATTERNS[cardType].test(cvv);
};

const isValidCard = (cardNumber) =>
  card.isValid(cardNumber?.toString?.()?.replace?.(/ /g, ''));

export {
  card,
  CARD_TYPES,
  isValidCvv,
  isValidCard,
  cardExpiryFormat,
  validateExpiryDate,
};
